import React, { useEffect, useState } from 'react';
import { getDatabase, ref, onValue, update, set, remove, get, child } from "firebase/database";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import AdminSidebar from '../../Components/DashBar';
import {
    FaCalendarTimes,
    FaUserSlash,
    FaListUl,
    FaMoneyBillWave,
    FaSave,
    FaPlus,
    FaTrashAlt,
    FaCalendarCheck
} from 'react-icons/fa';
import './Updates.css';

function Updates() {
    const [inputValue, setInputValue] = useState('');
    const [lockedDates, setLockedDates] = useState({});
    const [Prices, setPrices] = useState([]);
    const [Phone, setPhone] = useState('');
    const [customItemsEn, setCustomItemsEn] = useState([]);
    const [customItemsKn, setCustomItemsKn] = useState([]);
    const db = getDatabase();

    const [selectedDate, setSelectedDate] = useState(new Date());

    useEffect(() => {
        const starCountRef = ref(db, 'available_month');
        onValue(starCountRef, (snapshot) => {
            const data = snapshot.val();
            if (data && data.Value !== undefined) {
                setInputValue(data.Value);
            }
        });

        const starCountRef1 = ref(db, 'Prices');
        onValue(starCountRef1, (snapshot) => {
            const data = snapshot.val();
            if (data) {
                const sortedData = Object.entries(data)
                    .map(([month, monthData]) => ({
                        month: month,
                        numericalMonth: getNumericalMonth(month),
                        data: monthData || {}
                    }))
                    .sort((a, b) => a.numericalMonth - b.numericalMonth);
                setPrices(sortedData);
            }
        });

        const starCountRef3 = ref(db, 'bookedDates');
        onValue(starCountRef3, (snapshot) => {
            const data = snapshot.val();
            setLockedDates(data || {});
        });

        const queryEn = ref(db, "Functions/EN-en/functionList");
        onValue(queryEn, (snapshot) => {
            const data = snapshot.val();
            const getdata = [];
            if (snapshot.exists() && data) {
                getdata.push({ label: '--Select Event--', value: 'Null' });
                Object.values(data).forEach((res) => {
                    getdata.push({ label: res, value: res });
                });
                setCustomItemsEn(getdata);
            }
        });

        const queryKn = ref(db, "Functions/KN-kn/functionList");
        onValue(queryKn, (snapshot) => {
            const data = snapshot.val();
            const getdata = [];
            if (snapshot.exists() && data) {
                getdata.push({ label: '--Select Event--', value: 'Null' });
                Object.values(data).forEach((res) => {
                    getdata.push({ label: res, value: res });
                });
                setCustomItemsKn(getdata);
            }
        });
    }, [db]);

    const getNumericalMonth = (month) => {
        const monthNames = [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
        ];
        return monthNames.indexOf(month) + 1;
    };

    const getCleanNumber = (val) => {
        if (!val && val !== 0) return 0;
        const num = parseInt(String(val).replace('/-', '').trim(), 10);
        return isNaN(num) ? 0 : num;
    };

    const handleInputChange = (event) => {
        setInputValue(event.target.value);
    };

    const handlePriceFieldChange = (index, field, value) => {
        const newData = [...Prices];
        const cleanVal = value.replace(/[^0-9]/g, '');
        newData[index] = {
            ...newData[index],
            data: {
                ...newData[index].data,
                [field]: cleanVal === '' ? '0/-' : cleanVal + '/-'
            }
        };
        setPrices(newData);
    };

    const handleUpdate = (month) => {
        const selectedMonthData = Prices.find(entry => entry.month === month);
        if (!selectedMonthData || !selectedMonthData.data) return;

        const acValue = getCleanNumber(selectedMonthData.data.Ac);
        const acGST = getCleanNumber(selectedMonthData.data.Ac_Gst);
        const nonAcValue = getCleanNumber(selectedMonthData.data.Non_Ac);
        const nonAcGST = getCleanNumber(selectedMonthData.data.Non_Ac_Gst);
        const minPrice = getCleanNumber(selectedMonthData.data.Min_price);
        const acTotal = acValue + acGST;
        const NonAcTotal = nonAcValue + nonAcGST;

        alert(`Updating values for ${month}\nAC Total: ₹${acTotal}/-\nNon-AC Total: ₹${NonAcTotal}/-`);

        const updates = {};
        updates['/Prices/' + month] = {
            Ac: acValue + '/-',
            Ac_Gst: acGST + '/-',
            Non_Ac: nonAcValue + '/-',
            Non_Ac_Gst: nonAcGST + '/-',
            Min_price: minPrice + '/-',
            acTotal: acTotal + '/-',
            NonAcTotal: NonAcTotal + '/-'
        };
        update(ref(db), updates);
    };

    const formatDate = (dateString) => {
        const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
        const date = new Date(dateString);
        return date.toLocaleDateString('en-IN', options);
    };

    const handleDateUpdate = () => {
        const formatedDate = formatDate(selectedDate);
        let timeNow = new Date().getTime();
        const foundItem = Object.entries(lockedDates || {}).find(([key, value]) => {
            return value.formatedDate === formatedDate;
        });
        if (foundItem) {
            alert(`${formatedDate} already blocked`);
        } else {
            alert(`Blocked date: ${formatedDate}`);
            set(ref(db, 'bookedDates/' + timeNow), {
                formatedDate,
                blocked: true,
                status: "blocked"
            });
        }
    };

    const handleDateUnBlockUpdate = () => {
        const formatedDate = formatDate(selectedDate);
        const foundItem = Object.entries(lockedDates || {}).find(([key, value]) => {
            return value.formatedDate === formatedDate;
        });

        if (foundItem) {
            const [parentId, data] = foundItem;
            if (data.blocked === true) {
                remove(ref(db, "/bookedDates/" + parentId));
                alert(`Unblocked Date: ${formatedDate}`);
            } else {
                alert(`${formatedDate} this date is Booked by customer`);
            }
        } else {
            alert(`${formatedDate} this date not blocked`);
        }
    };

    const handleClick = () => {
        if (inputValue > 0 && inputValue < 13) {
            const updates = {};
            updates['/available_month/Value'] = Number(inputValue);
            update(ref(db), updates);
            alert('Display Months updated successfully');
        } else {
            alert('Months range should be between 1 to 12');
        }
    };

    const handlePhoneUpdate = () => {
        if (!Phone || String(Phone).trim() === '') {
            alert('Please enter a valid phone number');
            return;
        }
        const cleanPhone = String(Phone).trim();
        const starCountRef = ref(db);
        get(child(starCountRef, 'UsersList/' + cleanPhone)).then((snapshot) => {
            const data1 = snapshot.val();
            if (snapshot.exists()) {
                const updates = {};
                updates['UsersList/' + cleanPhone] = {
                    ...data1,
                    blocked: true
                };
                update(ref(db), updates);
                alert(`User ${cleanPhone} has been blocked`);
            } else {
                alert("User not found");
            }
        });
    };

    const handlePhoneUnBlockUpdate = () => {
        if (!Phone || String(Phone).trim() === '') {
            alert('Please enter a valid phone number');
            return;
        }
        const cleanPhone = String(Phone).trim();
        const starCountRef = ref(db);
        get(child(starCountRef, 'UsersList/' + cleanPhone)).then((snapshot) => {
            const data1 = snapshot.val();
            if (snapshot.exists()) {
                const updates = {};
                updates['UsersList/' + cleanPhone] = {
                    ...data1,
                    blocked: false
                };
                update(ref(db), updates);
                alert(`User ${cleanPhone} has been unblocked`);
            } else {
                alert("User not found");
            }
        });
    };

    function ListboxWithDropdown() {
        const [selectedItemEn, setSelectedItemEn] = useState('Null');
        const [selectedItemKn, setSelectedItemKn] = useState('Null');
        const [newItemEn, setNewItemEn] = useState('');
        const [newItemKn, setNewItemKn] = useState('');

        const handleAddItem = () => {
            const date = new Date();
            let added = false;

            if (newItemEn.trim() !== '') {
                const newOption = { label: newItemEn.trim(), value: newItemEn.trim() };
                const updatedItems = [...customItemsEn, newOption].filter(item => item.value !== 'Null');
                const functionList = {};
                updatedItems.forEach((item, index) => {
                    functionList[date.getTime() + index] = item.value;
                });
                set(ref(db, 'Functions/EN-en'), { functionList });
                setNewItemEn('');
                added = true;
            }

            if (newItemKn.trim() !== '') {
                const newOption = { label: newItemKn.trim(), value: newItemKn.trim() };
                const updatedItems = [...customItemsKn, newOption].filter(item => item.value !== 'Null');
                const functionList = {};
                updatedItems.forEach((item, index) => {
                    functionList[date.getTime() + index] = item.value;
                });
                set(ref(db, 'Functions/KN-kn'), { functionList });
                setNewItemKn('');
                added = true;
            }

            if (added) {
                alert('Function event added successfully');
            } else {
                alert('Please enter an event name in English or Kannada');
            }
        };

        const handleDeleteItem = () => {
            const date = new Date();
            let deleted = false;

            if (selectedItemEn !== 'Null') {
                const updatedItems = customItemsEn.filter(item => item.value !== selectedItemEn && item.value !== 'Null');
                const functionList = {};
                updatedItems.forEach((item, index) => {
                    functionList[date.getTime() + index] = item.value;
                });
                set(ref(db, 'Functions/EN-en'), { functionList });
                setSelectedItemEn('Null');
                deleted = true;
            }

            if (selectedItemKn !== 'Null') {
                const updatedItems = customItemsKn.filter(item => item.value !== selectedItemKn && item.value !== 'Null');
                const functionList = {};
                updatedItems.forEach((item, index) => {
                    functionList[date.getTime() + index] = item.value;
                });
                set(ref(db, 'Functions/KN-kn'), { functionList });
                setSelectedItemKn('Null');
                deleted = true;
            }

            if (deleted) {
                alert('Function event deleted successfully');
            } else {
                alert('Please select an event to delete');
            }
        };

        return (
            <div className="updates-functions-section">
                {/* Add Event Box */}
                <div className="updates-sub-box">
                    <div>
                        <h4 className="updates-sub-title">
                            <FaPlus style={{ color: 'var(--color-primary, #c0844a)' }} /> Add Function Event
                        </h4>
                        <div className="updates-two-col">
                            <div className="updates-form-group">
                                <label className="updates-form-label">English Name</label>
                                <input
                                    type="text"
                                    className="updates-input"
                                    value={newItemEn}
                                    onChange={(e) => setNewItemEn(e.target.value)}
                                    placeholder="e.g. Wedding Reception"
                                />
                            </div>
                            <div className="updates-form-group">
                                <label className="updates-form-label">Kannada Name</label>
                                <input
                                    type="text"
                                    className="updates-input"
                                    value={newItemKn}
                                    onChange={(e) => setNewItemKn(e.target.value)}
                                    placeholder="e.g. ಮದುವೆ ಸಮಾರಂಭ"
                                />
                            </div>
                        </div>
                    </div>
                    <button onClick={handleAddItem} className="updates-btn updates-btn-primary">
                        <FaPlus /> Add Function
                    </button>
                </div>

                {/* Delete Event Box */}
                <div className="updates-sub-box">
                    <div>
                        <h4 className="updates-sub-title">
                            <FaTrashAlt style={{ color: '#dc3545' }} /> Delete Function Event
                        </h4>
                        <div className="updates-two-col">
                            <div className="updates-form-group">
                                <label className="updates-form-label">English Event</label>
                                <select
                                    className="updates-select"
                                    value={selectedItemEn}
                                    onChange={(e) => setSelectedItemEn(e.target.value)}
                                >
                                    {customItemsEn.map((item, index) => (
                                        <option key={index} value={item.value}>
                                            {item.label}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="updates-form-group">
                                <label className="updates-form-label">Kannada Event</label>
                                <select
                                    className="updates-select"
                                    value={selectedItemKn}
                                    onChange={(e) => setSelectedItemKn(e.target.value)}
                                >
                                    {customItemsKn.map((item, index) => (
                                        <option key={index} value={item.value}>
                                            {item.label}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>
                    <button onClick={handleDeleteItem} className="updates-btn updates-btn-danger">
                        <FaTrashAlt /> Delete Selected
                    </button>
                </div>
            </div>
        );
    }

    return (
        <AdminSidebar>
            <div className="updates-page-wrapper">
                {/* Header */}
                <header className="updates-page-header">
                    <span className="updates-badge">Admin Controls</span>
                    <h1 className="updates-title">System Updates & Settings</h1>
                    <p className="updates-subtitle">
                        Manage display calendar months, lock/unlock dates, restrict users, configure booking function types, and update monthly hall pricing.
                    </p>
                </header>

                {/* Quick Controls Grid (3 Cards) */}
                <div className="updates-settings-grid">
                    {/* Display Months */}
                    <div className="updates-card">
                        <div>
                            <div className="updates-card-header">
                                <h3 className="updates-card-title">
                                    <FaCalendarCheck style={{ color: 'var(--color-primary, #c0844a)' }} /> Display Months
                                </h3>
                            </div>
                            <p className="updates-card-desc">
                                Advance months visible to customers on booking calendar (1–12).
                            </p>
                        </div>
                        <div className="updates-input-row">
                            <input
                                type="number"
                                min="1"
                                max="12"
                                className="updates-input"
                                value={inputValue}
                                onChange={handleInputChange}
                                placeholder="Months (1-12)"
                            />
                            <button onClick={handleClick} className="updates-btn updates-btn-primary">
                                <FaSave /> Update
                            </button>
                        </div>
                    </div>

                    {/* Block Date */}
                    <div className="updates-card">
                        <div>
                            <div className="updates-card-header">
                                <h3 className="updates-card-title">
                                    <FaCalendarTimes style={{ color: '#dc3545' }} /> Block / Unblock Date
                                </h3>
                            </div>
                            <p className="updates-card-desc">
                                Select a specific calendar date to block from bookings or restore it.
                            </p>
                        </div>
                        <div className="updates-form-group">
                            <div className="updates-datepicker-wrap">
                                <DatePicker
                                    selected={selectedDate}
                                    onChange={date => setSelectedDate(date)}
                                    dateFormat="dd/MM/yyyy"
                                    showYearDropdown
                                    scrollableYearDropdown
                                    yearDropdownItemNumber={15}
                                />
                            </div>
                        </div>
                        <div className="updates-btn-group">
                            <button onClick={handleDateUpdate} className="updates-btn updates-btn-danger">
                                Block
                            </button>
                            <button onClick={handleDateUnBlockUpdate} className="updates-btn updates-btn-outline">
                                Unblock
                            </button>
                        </div>
                    </div>

                    {/* Block User */}
                    <div className="updates-card">
                        <div>
                            <div className="updates-card-header">
                                <h3 className="updates-card-title">
                                    <FaUserSlash style={{ color: '#dc3545' }} /> Block / Unblock User
                                </h3>
                            </div>
                            <p className="updates-card-desc">
                                Enter user phone number to restrict access or restore booking rights.
                            </p>
                        </div>
                        <div className="updates-form-group">
                            <input
                                type="tel"
                                className="updates-input"
                                placeholder="Enter Phone Number"
                                value={Phone}
                                onChange={(e) => setPhone(e.target.value)}
                            />
                        </div>
                        <div className="updates-btn-group">
                            <button onClick={handlePhoneUpdate} className="updates-btn updates-btn-danger">
                                Block
                            </button>
                            <button onClick={handlePhoneUnBlockUpdate} className="updates-btn updates-btn-outline">
                                Unblock
                            </button>
                        </div>
                    </div>
                </div>

                {/* Event Functions Manager Card */}
                <div className="updates-card">
                    <div className="updates-card-header">
                        <h3 className="updates-card-title">
                            <FaListUl style={{ color: 'var(--color-primary, #c0844a)' }} /> Event Functions Management
                        </h3>
                    </div>
                    <p className="updates-card-desc">
                        Add new function types in English & Kannada or remove existing events from dropdown selections.
                    </p>
                    <ListboxWithDropdown />
                </div>

                {/* Monthly Prices Section */}
                <div className="updates-prices-header">
                    <div>
                        <h2 className="updates-prices-title">
                            <FaMoneyBillWave style={{ color: 'var(--color-primary, #c0844a)', marginRight: 8 }} />
                            Update Monthly Prices
                        </h2>
                        <p className="updates-card-desc" style={{ marginTop: 4 }}>
                            Configure base rates, GST, and minimum advance amounts for AC and Non-AC halls.
                        </p>
                    </div>
                </div>

                {/* Responsive Month Price Cards Grid */}
                <div className="updates-prices-grid">
                    {Prices.map((entry, index) => {
                        const acBase = getCleanNumber(entry?.data?.Ac);
                        const acGST = getCleanNumber(entry?.data?.Ac_Gst);
                        const acTotal = acBase + acGST;

                        const nonAcBase = getCleanNumber(entry?.data?.Non_Ac);
                        const nonAcGST = getCleanNumber(entry?.data?.Non_Ac_Gst);
                        const nonAcTotal = nonAcBase + nonAcGST;

                        const minPrice = getCleanNumber(entry?.data?.Min_price);

                        return (
                            <div key={index} className="month-price-card">
                                <div>
                                    {/* Month Card Header */}
                                    <div className="month-card-top">
                                        <div className="month-card-name-group">
                                            <span className="month-badge">
                                                {entry.numericalMonth || index + 1}
                                            </span>
                                            <h4 className="month-card-title">{entry.month}</h4>
                                        </div>
                                        <button
                                            onClick={() => handleUpdate(entry.month)}
                                            className="updates-btn updates-btn-primary updates-btn-sm"
                                            title={`Save ${entry.month} prices`}
                                        >
                                            <FaSave /> Save
                                        </button>
                                    </div>

                                    {/* AC Hall Block */}
                                    <div className="price-tier-block">
                                        <div className="price-tier-header">
                                            <span className="price-tier-label">AC Hall</span>
                                            <span className="price-tier-total-badge">
                                                Total: ₹{acTotal}/-
                                            </span>
                                        </div>
                                        <div className="price-tier-inputs">
                                            <div className="price-input-mini">
                                                <label>Base Price</label>
                                                <input
                                                    type="text"
                                                    value={acBase}
                                                    onChange={(e) => handlePriceFieldChange(index, 'Ac', e.target.value)}
                                                    placeholder="0"
                                                />
                                            </div>
                                            <div className="price-input-mini">
                                                <label>+ GST</label>
                                                <input
                                                    type="text"
                                                    value={acGST}
                                                    onChange={(e) => handlePriceFieldChange(index, 'Ac_Gst', e.target.value)}
                                                    placeholder="0"
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {/* Non-AC Hall Block */}
                                    <div className="price-tier-block">
                                        <div className="price-tier-header">
                                            <span className="price-tier-label">Non-AC Hall</span>
                                            <span className="price-tier-total-badge">
                                                Total: ₹{nonAcTotal}/-
                                            </span>
                                        </div>
                                        <div className="price-tier-inputs">
                                            <div className="price-input-mini">
                                                <label>Base Price</label>
                                                <input
                                                    type="text"
                                                    value={nonAcBase}
                                                    onChange={(e) => handlePriceFieldChange(index, 'Non_Ac', e.target.value)}
                                                    placeholder="0"
                                                />
                                            </div>
                                            <div className="price-input-mini">
                                                <label>+ GST</label>
                                                <input
                                                    type="text"
                                                    value={nonAcGST}
                                                    onChange={(e) => handlePriceFieldChange(index, 'Non_Ac_Gst', e.target.value)}
                                                    placeholder="0"
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {/* Minimum Advance Amount */}
                                    <div className="price-min-amount-block">
                                        <label>Minimum Amount (Advance):</label>
                                        <input
                                            type="text"
                                            value={minPrice}
                                            onChange={(e) => handlePriceFieldChange(index, 'Min_price', e.target.value)}
                                            placeholder="0"
                                        />
                                    </div>
                                </div>

                                {/* Bottom Full-width Save Button for Mobile Friendly Tap */}
                                <div className="month-card-action">
                                    <button
                                        onClick={() => handleUpdate(entry.month)}
                                        className="updates-btn updates-btn-primary"
                                    >
                                        <FaSave /> Update {entry.month} Prices
                                    </button>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </AdminSidebar>
    );
}

export default Updates;
